import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  DcDashboardProvider,
  DcDashboardStore,
} from '../../providers/dcDashboard';
import { SAVINGS_SUMMARY } from '../../routes/types';
import SavingsSnapshot from '../widgets/dashboards/SavingsSnapshot';

const linksData = [
  {
    linkHeader: 'Savings Summary',
    route: SAVINGS_SUMMARY,
  },
];

const DcInactiveDashboardView = () => {
  const { fingertipLinks, companiesMessages, savingsSnapshot } =
    useContext(DcDashboardStore) || {};

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">Welcome, Terry!</div>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row className="text-sm-12-lg-14 p-0">
                  <Col className=" text-nowrap col-12 fw-light">
                    There are currently no events.
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Col className="m-0 p-0 d-flex flex-column col-12 col-lg-7 pe-lg-4">
          <SavingsSnapshot
            savingsSnapshot={savingsSnapshot}
            linksData={linksData}
          />
        </Col>

        <Col className="col-12 col-lg-5 pe-0">
          <Col className="pe-lg-0 col-12">
            <FingerTipsLinks data={fingertipLinks} className="p-0" />
          </Col>
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const DcInactiveDashboard = () => {
  return (
    <DcDashboardProvider>
      <DcInactiveDashboardView />
    </DcDashboardProvider>
  );
};

export default DcInactiveDashboard;
